import { combineReducers } from '@reduxjs/toolkit';

import { api } from './api';
import companyPageReducer from './companyPage';
import extraReducer from './extraReducer';
import jobsReducer from './jobs';
import localsReducer from './locals';
import modalsReducer from './modals';
import postJobReducer from './postJob';
import resumeBuilderReducer from './resumeBuilder';
import searchFilterReducer from './searchFilter';
import { trackingReducer } from './tracking';
import userReducer from './user';
import userProfilePageReducer from './userProfilePage';

const reducer = combineReducers({
  user: userReducer,
  locals: localsReducer,
  searchFilter: searchFilterReducer,
  modals: modalsReducer,
  jobs: jobsReducer,
  companyPage: companyPageReducer,
  postJob: postJobReducer,
  userProfilePage: userProfilePageReducer,
  resumeBuilder: resumeBuilderReducer,
  extra: extraReducer,
  tracking: trackingReducer,
  [api.reducerPath]: api.reducer,
});

export default reducer;
